import React, { Fragment } from 'react';
import { object } from 'prop-types';
import Helmet from 'react-helmet';
import { ThemeProvider } from 'styled-components';

import SubRoutes from './SubRoutes.jsx';
import Page from '~/views/common/Page/index.js';
import ScrollToTop from '~/views/enhancers/ScrollToTop.jsx';

import withAppState from '~/views/enhancers/withAppState.js';

import theme from '~/styleUtils/theme.js';


const Root = ({
    route,
    location,
}) => (
    <Fragment>
        <Helmet
            titleTemplate="%s | Starkiller Base"
            defaultTitle="Starkiller Base"
            titleAttributes={{ itemprop: 'name', lang: 'en' }}
            meta={[
                { name: 'description', content: 'TreeTop Admin Site' },
                { name: 'viewport', content: 'width=device-width, initial-scale=1' },
            ]}
        />

        <ThemeProvider theme={theme}>
            <ScrollToTop>
                <Page location={location}>
                    <SubRoutes route={route} />
                </Page>
            </ScrollToTop>
        </ThemeProvider>
    </Fragment>
);

Root.propTypes = {
    route: object.isRequired,
    location: object.isRequired,
};

export default withAppState(Root);
